import React, { useEffect, useRef, useState } from "react";
import "./airdrop.css";
import airdropGifSmall from "../../assets/airdropGifSmall.gif";
import airdropBox from "../../assets/airdropBox.svg";
import airdropBoxInactive from "../../assets/airdropBoxInactive.svg";
import Slider from "react-slick";
import getFormattedNumber from "../../hooks/getFormattedNumber";
import airdropArrow from "../../assets/airdropArrow.svg";
import tooltip from "../../assets/tooltip.svg";
import OutsideClickHandler from "react-outside-click-handler";

const Airdrop = () => {
  const [active, setActive] = useState(null);
  const [activeIndex, setActiveIndex] = useState(null);
  const sliderRef = useRef(null);
  const [tooltipInfo, setTooltipInfo] = useState(false);

  const userCount = 69849;

  const settings = {
    className: "center",
    centerMode: true,
    infinite: false,
    centerPadding: "60px",
    slidesToShow: 1,
    speed: 500,
    afterChange: (current) => {
      setActiveIndex(current);
    },
  };

  const dummyCards = [
    {
      amount: 20000,
      usersRequired: 50000,
      level: 1,
    },
    {
      amount: 50000,
      usersRequired: 100000,
      level: 2,
    },
    {
      amount: 250000,
      usersRequired: 500000,
      level: 3,
    },
    {
      amount: 500000,
      usersRequired: 1000000,
      level: 4,
    },
    {
      amount: 750000,
      usersRequired: 2000000,
      level: 5,
    },
    {
      amount: 1500000,
      usersRequired: 5000000,
      level: 6,
    },
  ];
  const nextSlide = () => {
    sliderRef.current.slickNext();
  };
  const prevSlide = () => {
    sliderRef.current.slickPrev();
  };

  useEffect(() => {
    const activeCard = dummyCards
      .slice() // Copy the array so we don't modify the original
      .reverse() // Check from highest to lowest
      .find((card) => userCount >= card.usersRequired)?.level;

    setActive(activeCard || null);
    // setActiveIndex(activeCard + 1)
    sliderRef.current?.slickGoTo(activeCard - 1);
    if (activeCard) {
      setActiveIndex(activeCard - 1);
    } else {
      setActiveIndex(0);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userCount]);

  return (
    <div className="container-fluid px-0 airdrop-wrapper position-relative d-flex flex-column justify-content-start gap-1 mb-3">
     <div className="d-flex w-100 justify-content-center position-relative gif-bg py-3">
     <img
        src={airdropGifSmall}
        alt="airdrop banner"
        className="airdrop-banner"
      />
     </div>
      <div className="position-relative d-flex align-items-center justify-content-end px-3">
        <img
          src={tooltip}
          width={24}
          height={24}
          style={{ cursor: "pointer" }}
          alt=""
          onClick={() => setTooltipInfo(true)}
        />
        <OutsideClickHandler onOutsideClick={() => setTooltipInfo(false)}>
          <div
            className={`airdrop-tooltip-content-wrapper ${
              tooltipInfo && "airdrop-tooltip-active"
            }`}
          >
            <span>
              Reaching a milestone doesn’t trigger immediate distribution. All
              unlocked milestones will be distributed between March and June
              2025, based on the milestones achieved by then.
            </span>
          </div>
        </OutsideClickHandler>
      </div>
          <div className="position-relative">
          <img
        src={airdropArrow}
        width={40}
        height={40}
        onClick={prevSlide}
        alt=""
        className="prev-arrow-airdrop"
        style={{ transform: "rotate(180deg)" }}
      />
      <img
        src={airdropArrow}
        width={40}
        height={40}
        onClick={nextSlide}
        alt=""
        className="next-arrow-airdrop"
      />
      <Slider {...settings} ref={sliderRef}>
        {dummyCards.map((item, index) => (
          <div className="px-2 pb-3">
            <div
              className={`airdrop-card ${
                activeIndex === index && "airdrop-card-active"
              } d-flex flex-column`}
              key={index}
            >
              <div
                className="airdrop-card-header d-flex flex-column align-items-center justify-content-center gap-2 p-3"
                style={{
                  background: active === item.level ? "#5690FF" : "#9199AB",
                }}
              >
                <img
                  src={active === item.level ? airdropBox : airdropBoxInactive}
                  alt="airdrop-box"
                />
                <h6 className="mb-0 airdrop-reward-amount">
                  ${getFormattedNumber(item.amount, 0)}
                </h6>
                <span className="airdrop-reward-desc">Reward Pool</span>
              </div>
              <div className="airdrop-card-body p-3 d-flex flex-column gap-2">
                <div className="d-flex w-100 justify-content-center">
                  <span
                    className="airdrop-card-level"
                    style={{
                      color: active === item.level ? "#5690FF" : "#9199AB",
                    }}
                  >
                    Level {item.level}
                  </span>
                </div>
                <p
                  className="mb-0 airdrop-card-desc"
                  style={{
                    color: active === item.level ? "#5690FF" : "#9199AB",
                  }}
                >
                  The app reached a milestone of{" "}
                  {getFormattedNumber(item.usersRequired, 0)} users
                </p>
                {/* <div className="airdrop-card-divider"></div>
                <p
                  className="mb-0 airdrop-card-desc"
                  style={{
                    color: active === item.level ? "#4F5F90" : "#9199AB",
                  }}
                >
                  Distribution: WOD, BNB, ETH, CORE, TAIKO, MANTA, and other
                  rewards from partner networks.
                </p> */}
              </div>
            </div>
          </div>
        ))}
      </Slider>
          </div>
    </div>
  );
};

export default Airdrop;
